import { Link } from 'react-router-dom';
import { MailCheck } from 'lucide-react';

/**
 * Nudge shown to "soft" (instant /optin) sessions: they can browse the free
 * course right away, but should confirm their email to keep access and unlock a
 * password. The link goes to /login (pre-filled), where OTP / magic link issues
 * a full (non-soft) session.
 */
export function SoftAccessBanner({ email }: { email: string }) {
  return (
    <div className="flex items-start gap-3 rounded-lg border border-primary/30 bg-primary/5 p-4">
      <MailCheck className="mt-0.5 size-5 shrink-0 text-primary-strong" />
      <div className="space-y-2">
        <p className="text-sm font-medium text-foreground">
          Du bist sofort eingeloggt.
        </p>
        <p className="text-sm text-muted-foreground">
          Bestätige deine E-Mail-Adresse, um deinen Zugang dauerhaft zu sichern und ein Passwort zu vergeben.
        </p>
        <Link
          to={`/login?email=${encodeURIComponent(email)}`}
          className="inline-flex items-center rounded-md bg-primary px-3 py-1.5 text-xs font-medium text-primary-foreground transition hover:opacity-90"
        >
          E-Mail bestätigen
        </Link>
      </div>
    </div>
  );
}
